import { useTranslations } from 'next-intl'

import { cn } from '@/shared/lib'

type Props = {
  className?: string
  textClassName?: string
}

export const SuperHostBadge = ({ className, textClassName }: Props) => {
  const t = useTranslations('room_detail')

  return (
    <div
      className={cn(
        'flex h-8 w-full items-center justify-center rounded-t-sm',
        className,
      )}
      style={{
        background:
          'linear-gradient(0deg, rgba(255, 255, 255, 0.30) 0%, rgba(255, 255, 255, 0.30) 100%), linear-gradient(90deg, rgba(78, 144, 249, 0.00) 24.88%, rgba(54, 130, 250, 0.60) 53.56%, rgba(78, 144, 249, 0.00) 91.72%), linear-gradient(90deg, rgba(137, 95, 252, 0.00) -96%, #9E7AFF 31.49%, rgba(137, 95, 252, 0.00) 215.24%), #FFF',
      }}
    >
      <span className={cn('typo-label2 font-medium text-white', textClassName)}>
        {t('landlord_profile.samsam_preferred_landlord')}
      </span>
    </div>
  )
}
